module.exports = __webpack_public_path__ + "3c6b1adb5469a95c9edcf7a87219b981.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/components/info-sharing-center/info-sharing-center-zh.html
// module id = 1045
// module chunks = 0